export default [
  'agendamentoSecretariaNotificacao',
  'assinarEnviar',
  'backoffice-alterar-cadastro-medico',
  'backoffice-chat-agendamento',
  'backoffice-chat-autorizacao',
  'backoffice-mapa-agendamento',
  'backoffice-mapa-anestesia',
  'backoffice-mapa-autorizacao',
  'backoffice-mapa-centralmateriaisespeciais',
  'backoffice-mapa-centrocirurgico',
  'backoffice-mapa-cirurgia-realizada',
  'backoffice-mapa-engenhariaclinica',
  'backoffice-mapa-farmacia',
  'backoffice-mapa-gerenciamentoleito',
  'backoffice-mapa-hotelaria',
  'backoffice-mapa-opme',
  'backoffice-mapa-preinternacao',
  'backoffice-mapa-suprimentos',
  'backoffice-mapa-tesouraria',
  'instrumentador',
  'backoffice-mapa-bancodesangue',
]
